import { Injectable } from '@angular/core';
import { ScoringParametrage } from '../model/ScoringParametrage';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';

@Injectable({
  providedIn: "root"
})
export class ScoringParametreService {
  constructor(private _restClientService: RestClientService) {}

  getAllScoringParametrage() {
    return this._restClientService.load<ScoringParametrage[]>(
      "scoring-parametrage/get"
    );
  }

  getScoringParametrageById(ferieId) {
    return this._restClientService.load<ScoringParametrage>(
      "scoring-parametrage/get/" + ferieId
    );
  }

  add(parametreGeneral) {
    return this._restClientService.save<ScoringParametrage>(
      "scoring-parametrage/add",
      parametreGeneral
    );
  }

  update(parametreGeneral) {
    return this._restClientService.put<ScoringParametrage>(
      `scoring-parametrage/update`,
      parametreGeneral
    );
  }

  delete(id) {
    return this._restClientService.delete<any>(
      "scoring-parametrage/delete/" + id
    );
  }
}
